export default "/images/vendor/@coreui/icons/svg/flag/cif-fr.svg?c629d322a1a89b73b6076524e155f9e4";